var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./social_page_group.static";
export class ApiEpSocialPageGroup {
}
ApiEpSocialPageGroup.common = {
    cancelDeffered: ({ id, organizationId, }) => apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup/${id}/cancel_deferred`,
        method: "POST",
        headers: organizationId
            ? [["X-Organization-Context", organizationId.toString()]]
            : undefined,
    }, failureHash),
};
/**
 * Used to create new SocialPageGroup
 */
ApiEpSocialPageGroup.create = ({ name, organizationId, }) => apiRequest({
    body: { name },
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup`,
    headers: organizationId
        ? [["X-Organization-Context", organizationId.toString()]]
        : undefined,
    method: "POST",
}, failureHash);
/**
 * Used to delete SocialPageGroup by id
 */
ApiEpSocialPageGroup.destroy = ({ id, organizationId, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup/${id}`,
    headers: organizationId
        ? [["X-Organization-Context", organizationId.toString()]]
        : undefined,
    method: "DELETE",
}, failureHash);
/**
 * Used to get SocialPageGroup list
 */
ApiEpSocialPageGroup.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup`,
    method: "GET",
    query: req.query,
    headers: req.organizationId
        ? [["X-Organization-Context", req.organizationId.toString()]]
        : undefined,
}, failureHash);
/**
 * Used to get SocialPageGroup by id
 */
ApiEpSocialPageGroup.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup/${req.path.id}`,
    method: "GET",
    query: req.query,
}, failureHash);
/**
 * Used to update existing SocialPageGroup
 */
ApiEpSocialPageGroup.rewrite = ({ fields, socialPageGroup, organizationId, }) => apiRequest({
    body: socialPageGroup,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup/${socialPageGroup.id}`,
    method: "PUT",
    query: {
        fields,
    },
    headers: organizationId
        ? [["X-Organization-Context", organizationId.toString()]]
        : undefined,
}, failureHash);
/**
 * Used to partial update existing SocialPageGroup
 */
ApiEpSocialPageGroup.update = (_a) => {
    var { fields } = _a, _b = _a.socialPageGroup, { id } = _b, data = __rest(_b, ["id"]), { organizationContext } = _a;
    return apiRequest({
        body: data,
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/socialpagegroup/${id}`,
        method: "PATCH",
        query: {
            fields,
        },
        headers: [["X-Organization-Context", String(organizationContext)]],
    }, failureHash);
};
//# sourceMappingURL=social_page_group.js.map